@if ((actionsLoadingState$ | async)) {
<aix-loading [relative]="true" [style]="styles.loading"></aix-loading>
}

<aix-document-action-bar
    (clickDownload)="onClickDownload()"
    (clickClose)="onClickClose()"
    [downloadAll]="true"
    [isReadOnly]="isReadOnly"
></aix-document-action-bar>

<div class="aix-viewer__main-wrapper">
    <aix-error-box [states]="states"></aix-error-box>

    <!-- #5517: per-order tabs when previewing a bundle; switching re-points the viewer at that order. -->
    @if (bundleTabs.length > 1) {
    <div class="aix-viewer__bundle-tabs ph-unmask">
        @for (tab of bundleTabs; track tab.id) {
        <button
            type="button"
            class="aix-viewer__bundle-tab"
            [class.active]="tab.id === activeBundleOrderId"
            (click)="onSelectBundleTab(tab.id)"
        >
            Order {{ tab.label }}
        </button>
        }
    </div>
    }

    @if (documentNotFound) {
    <aix-notification
        class="order-process-notification ph-unmask"
        status="alert"
        [data-testing]="'document-not-found-notification'"
        [canClose]="false"
        [isOpen]="true"
    >
        That document is no longer on this order. Showing the order's current documents.
    </aix-notification>
    } @if (isReadOnly) {
    <aix-notification
        class="order-process-notification ph-unmask"
        status="alert"
        [data-testing]="'read-only-notification'"
        [canClose]="false"
        [isOpen]="true"
    >
        You have read-only access to this order. You can view but not make changes.
    </aix-notification>
    } @if (hasComments) {
    <aix-notification
        class="order-process-notification ph-unmask"
        status="warning"
        [data-testing]="'read-only-notification'"
        [canClose]="true"
        [isOpen]="true"
    >
        <b>You have replied to all "Needs Clarification" comments.</b>
        @if (!needsChanges) {
        <p>Please <a class="br-link" (click)="returnOrder()">return order</a> for review.</p>
        } @if (needsChanges) {
        <p>Please <a class="br-link" (click)="editOrder()">edit order</a> and resubmit.</p>
        }
    </aix-notification>
    }

    <aix-notification
        #notification
        [status]="activeNotification.status"
        [data-testing]="'document-viewer-notification'"
        (onCloseNotification)="onCloseNotification()"
        [canClose]="canClose"
    >
        <div
            [style.fontWeight]="activeNotification.extras && activeNotification.extras.length > 0 ? 500 : 400"
        >
            {{ activeNotification.text }}
        </div>
        @if (activeNotification?.extras) {
        <div class="u-mt8">
            @for (extra of activeNotification.extras; track $index) {
            <span>
                @if (extra.type === 'text') {
                <span> {{ extra.text }} </span>
                } @if (extra.type === 'link') {
                <a (click)="store.dispatch(extra.action!)" class="br-link">{{ extra.text }}</a>
                }
            </span>
            }
        </div>
        }
    </aix-notification>

    <div class="flex-left-stretch flex-row u-full-width u-full-height">
        <div class="flex-fill u-full-width u-full-height">
            <aix-document-viewer [documentControls]="styles.documentControls" [signaturesPreview]="signaturesPreview" [hiddenRoles]="hiddenRoles" [wetSignOverride]="wetSignOverride"></aix-document-viewer>
        </div>

        @if ((storeFacade.orderSuccess$ | async) && !(storeFacade.documentViewer$ | async)?.offline)
        {
        <div class="aix-viewer__info-wrapper">
            <aix-document-tabs
                [signaturesPreview]="!!signaturesPreview && availableRoles.length > 0"
                [availableRoles]="availableRoles"
                [signaturesForRole]="signaturesForRole"
                [hiddenRoles]="hiddenRoles"
                [roleFieldIndex]="roleFieldIndex"
                (onToggleRole)="onToggleRole($event)"
                (onPrevSignature)="onPrevSignature($event)"
                (onNextSignature)="onNextSignature($event)"
                (onDownloadDocument)="onClickDownloadDocument($event)"
                (onNotOnboarded)="onNotOnboarded($event)"
            ></aix-document-tabs>
        </div>
        }
    </div>
</div>
